import React, { FC, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getProfileData } from 'data/src/redux/profile/selectors'

import { getActiveLink, getActiveTier1, getActiveTier2, getActiveTier3, Tier1Link, Link } from '../../../helpers/navStructure'
import { useAppSelector } from '../../../redux/hooks/hooks'

import Menu from './Menu'
import TopBarNav from './TopBarNav'
import { FEATURE_FLAGS } from '../../../config'
import { useRedNavigate } from 'web/src/dataImplementation/useRedNavigate'

const MainNavigation: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [selectedLink, setSelectedLink] = useState<Tier1Link | null>(null)
  const [highlightedTier2Link, setHighlightedTier2Link] = useState<Link | null>(null)
  const [highlightedTier3Link, setHighlightedTier3Link] = useState<Link | null>(null)
  const location = useLocation()
  const navigate = useRedNavigate()
  const activePath = getActiveLink(location.pathname)
  const activeTier1 = getActiveTier1(location.pathname)
  const activeTier2 = getActiveTier2(location.pathname)
  const activeTier3 = getActiveTier3(location.pathname)
  const activeParent = activePath?.parent?.label || 'Menu'
  const profile = useAppSelector(getProfileData)
  const isOnboarding = profile?.appState?.onboarding ? false : true
  const showAccountMenu = FEATURE_FLAGS.newSignUpFlow ? isOnboarding : true

  const closeMenu = (): void => {
    setIsMenuOpen(false)
    setSelectedLink(null)
    setHighlightedTier2Link(null)
    setHighlightedTier3Link(null)
  }

  const toggleMenu = (): void => {
    if (isMenuOpen) {
      closeMenu()
    } else {
      if (activeTier1) {
        setSelectedLink(activeTier1)
      }
      if (activeTier2) {
        setHighlightedTier2Link(activeTier2)
      } else {
        setHighlightedTier2Link(activeTier1)
      }
      if (activeTier3) {
        setHighlightedTier3Link(activeTier3)
      }
      setIsMenuOpen(true)
    }
  }

  const activeSectionSelected = (): void => {
    if (activePath?.parent) {
      navigate(activePath?.parent.href)
      closeMenu()
    } else {
      toggleMenu()
    }
  }

  return (
    <>
      <TopBarNav
        toggleMenu={toggleMenu}
        isMenuOpen={isMenuOpen}
        activeSectionSelected={activeSectionSelected}
        activeParent={activeParent}
        showAccountMenuButton={showAccountMenu}
      />
      <Menu
        selectedLink={selectedLink}
        onSelectedLink={setSelectedLink}
        highlightedTier2Link={highlightedTier2Link}
        onHighlightedTier2Link={(highlightedTier2Link): void => {
          setHighlightedTier2Link(highlightedTier2Link)
          setHighlightedTier3Link(null)
        }}
        highlightedTier3Link={highlightedTier3Link}
        onHighlightedTier3Link={(highlightedTier3Link): void => {
          setHighlightedTier3Link(highlightedTier3Link)
          setHighlightedTier2Link(null)
        }}
        isOpen={isMenuOpen}
        onClose={closeMenu}
      />
    </>
  )
}
export default MainNavigation
